import React, { useState } from "react";
import PropTypes from "prop-types";
import GlobalOverlay from "../globalOverlay/globalOverlay";
import "./learnMore.scss";
import { Tooltip } from "react-tooltip";
import { InfoIcon } from "../../assets/images/svg";

export default function LearnMore(props) {
  const [isVisible, setIsVisible] = useState(false);
  const {
    title,
    content,
    customStyles = {},
    html,
    link,
    direction = "right",
    additionalInfo = false,
    testId = "learnMoreButton"
  } = props;
  const handleLearnMore = () => {
    setIsVisible(!isVisible);
  };
  const openLink = () => {
    window.open(link, "_blank", "noopener noreferrer");
  };

  function returnMarkup() {
    return (
      <div className="learn-more__content" dangerouslySetInnerHTML={{ __html: props.content }} />
    );
  }

  return (
    <>
      <GlobalOverlay isVisible={isVisible} onClick={handleLearnMore} />
      <div className={`learn-more ${isVisible ? "learn-more--active" : ""}`} data-testid={testId}>
        <button
          className="learn-more__button"
          data-tooltip-html={link ? content : undefined}
          data-tooltip-id={`${title} tooltip`}
          onClick={link ? openLink : handleLearnMore}
        >
          {!additionalInfo ? (
            <InfoIcon className="infoIcon" />
          ) : (
            <span
              className="learn-more__tags-icon glyphicon glyphicon-tags"
              style={{ paddingTop: "1px" }}
            />
          )}
        </button>

        {isVisible && (
          <div
            className={`learn-more__overlay ${
              additionalInfo ? "learn-more__overlay--additional-info" : ""
            }`}
            style={{ ...customStyles }}
          >
            {title && <h2>{title}</h2>}
            {content &&
              (html ? returnMarkup() : <div className="learn-more__content">{content}</div>)}
          </div>
        )}
        {link && (
          <Tooltip className="learn-more__tooltip" id={`${title} tooltip`} place={direction} />
        )}
      </div>
    </>
  );
}

LearnMore.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  customStyles: PropTypes.object,
  html: PropTypes.bool,
  link: PropTypes.string,
  direction: PropTypes.oneOf(["top", "bottom", "left", "right"])
};
